export const BRAND_NAME = 'Marvel11';
// Note: It is the main site url. Ex - sky11.com, etc.
export const BRAND_DOMAIN = 'marvel11.com';
export const PROVIDER_ID = 'BetFair';
